import request from "./axios";

function index(params) {
  return request({
    method: "get",
    url: `/seminar_registrations`,
    params: params
  })
}

function get(id) {
  return request({
    method: "get",
    url: `/seminar_registrations/${id}`,
  })
}

function stats(id) {
  return request({
    method: "get",
    url: `/seminar_registrations/${id}/stats`
  })
}

function update(id, params) {
  return request({
    method: "patch",
    url: `/seminar_registrations/${id}`,
    data: { seminar_registration: params }
  })
}

function takeAction(action, id, params) {
  return request({
    method: "post",
    url: `/seminar_registrations/${id}/action/${action}`,
    data: { seminar_registration_action: params }
  })
}

function groupAction(action, params) {
  return request({
    method: "post",
    url: `/seminar_registrations/group_action/${action}`,
    data: params
  })
}

function createLMTasks(params) {
  return request({
    method: "post",
    url: `/deals/create_tasks`,
    data: params
  })
}
const SeminarRegistrationsService = {
  index, update, get, takeAction, groupAction, stats, createLMTasks
};

export default SeminarRegistrationsService;
